import { Component } from '@angular/core';
import { NavController,AlertController } from 'ionic-angular';
import { AppState } from '../../../../app/app.global';
import { SetPasswordPage } from '../setpwd/setpwd';
@Component({
  selector: 'login-children-page',
  templateUrl: 'submitinfo.html'
})
export class SubmitPersonalInfoPage {
	user={
		userId:'',
		userName:'',
		idNumber:''
	}
  constructor(public navCtrl: NavController,private alertCtrl: AlertController,public global: AppState) {
  }
  nextToSetPassword() {
  	if(this.user.userId == ""){
  		let alert = this.alertCtrl.create({
        subTitle: '学号或工号不能为空',
        buttons: ['确定']
      });
      alert.present();
  	}else if(this.user.userName == ""){
  		let alert = this.alertCtrl.create({
        subTitle: '用户名不能为空',
        buttons: ['确定']
      });
      alert.present();
  	}else if(this.user.idNumber == ""){
  		let alert = this.alertCtrl.create({
        subTitle: '身份证号不能为空',
        buttons: ['确定']
      });
      alert.present();
  	}else if(this.checkIdNumber(this.user.idNumber) !="true") {
  		let alert = this.alertCtrl.create({
        subTitle: this.checkIdNumber(this.user.idNumber),
        buttons: ['确定']
      });
      alert.present();
  	}else{
  		this.navCtrl.push(SetPasswordPage,this.user);
  	}

  }

  checkIdNumber(idNumber){
  	let aCity={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",
  	           21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",
  	           33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",
  	           41:"河南",42:"湖北",43:"湖南",44:"广东",45:"广西",
  	           46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",
  	           54:"西藏",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",
  	           65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"};
  	if(idNumber == ""){
  		return "输入的身份证格式有误";
  	}
  	let iSum=0 ;
  	if(!/^\d{17}(\d|x)$/i.test(idNumber)) return "输入的身份证格式有误";
  	idNumber=idNumber.replace(/x$/i,"a");
  	if(aCity[parseInt(idNumber.substr(0,2))]==null) return "身份证地区非法";
  	let sBirthday=idNumber.substr(6,4)+"-"+Number(idNumber.substr(10,2))+"-"+Number(idNumber.substr(12,2));
  	let d=new Date(sBirthday.replace(/-/g,"/")) ;
  	if(sBirthday!=(d.getFullYear()+"-"+ (d.getMonth()+1) + "-" + d.getDate()))return "出生日期非法";
  	for(var i = 17;i>=0;i --) iSum += (Math.pow(2,i) % 11) * parseInt(idNumber.charAt(17 - i),11) ;
  	if(iSum%11!=1) return "输入的身份证号非法";
  	return "true";
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/account/submitinfo/submitinfo.ts